(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-slide"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.AcuaFlyoutLoaded) return;
  window.AcuaFlyoutLoaded = true;

  var ICONS = {
    grid: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
    equipo: '<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>',
    refacciones: '<path d="M14.7 6.3a4 4 0 0 0-5.66 5.66L3 18l3 3 6.04-6.04a4 4 0 0 0 5.66-5.66l-2.51 2.51a1.5 1.5 0 0 1-2.12-2.12l2.63-2.39z"/>',
    repuesto: '<circle cx="12" cy="12" r="3"/><path d="M19.4 13a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.11-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 13a1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 6.85a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6h.07A1.7 1.7 0 0 0 10 3.05V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 4.6a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9v.07a1.7 1.7 0 0 0 1.55 1.02H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51.91z"/>',
    membrana: '<ellipse cx="12" cy="5" rx="7" ry="2.6"/><path d="M5 5v14c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6V5"/>',
    filtro: '<path d="M3 4h18l-7 8v7l-4 2v-9L3 4z"/>',
    bomba: '<circle cx="12" cy="12" r="9"/><path d="M12 12V7"/><path d="M12 12l3.5-2"/>',
    gota: '<path d="M12 3s6 6.5 6 10a6 6 0 0 1-12 0c0-3.5 6-10 6-10z"/>',
    quimico: '<path d="M9 3h6"/><path d="M10 3v6l-5.2 9A1.5 1.5 0 0 0 6.1 20.2h11.8A1.5 1.5 0 0 0 19.2 18L14 9V3"/>',
    accesorio: '<path d="M14.7 6.3a4 4 0 0 0-5.66 5.66L3 18l3 3 6.04-6.04a4 4 0 0 0 5.66-5.66l-2.51 2.51a1.5 1.5 0 0 1-2.12-2.12l2.63-2.39z"/>'
  };
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  function svg(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || ICONS.equipo) + '</svg>';
  }
  function touch() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var portal, panel, caret, scrim, current = null, closeT = null, rafPending = false;

  function build() {
    if (portal) return;
    scrim = document.createElement('div');
    scrim.className = 'acua-flyout-scrim';
    scrim.addEventListener('click', close);

    portal = document.createElement('div');
    portal.className = 'acua-flyout';
    caret = document.createElement('span');
    caret.className = 'acua-flyout__caret';
    panel = document.createElement('div');
    panel.className = 'acua-flyout__panel';
    portal.appendChild(caret);
    portal.appendChild(panel);

    portal.addEventListener('mouseenter', function () { if (!touch()) cancelClose(); });
    portal.addEventListener('mouseleave', function () { if (!touch()) scheduleClose(); });

    document.body.appendChild(scrim);
    document.body.appendChild(portal);
  }

  function render(trigger) {
    var src = trigger.querySelector('.acua-cat-card__source');
    if (!src) return false;
    var title = src.getAttribute('data-title') || '';
    var links = src.querySelectorAll('.acua-sub');
    var html = title ? '<p class="acua-flyout__title">' + escapeHtml(title) + '</p>' : '';
    html += '<div class="acua-flyout__list">';
    Array.prototype.forEach.call(links, function (a) {
      var isAll = a.classList.contains('acua-sub--all');
      var icon = isAll ? 'grid' : (a.getAttribute('data-icon') || 'equipo');
      var img = a.getAttribute('data-img');
      var desc = a.getAttribute('data-desc') || '';
      var label = (a.textContent || '').trim();
      var icoInner = (!isAll && img) ? '<img src="' + img + '" alt="" loading="lazy">' : svg(icon);
      var icoClass = 'acua-flyout__ico' + ((!isAll && img) ? ' acua-flyout__ico--img' : '');
      html += '<a class="acua-flyout__item' + (isAll ? ' acua-flyout__item--all' : '') + '" href="' + a.getAttribute('href') + '" role="menuitem">'
        + '<span class="' + icoClass + '">' + icoInner + '</span>'
        + '<span class="acua-flyout__txt"><span class="acua-flyout__lbl">' + escapeHtml(label) + '</span>'
        + (desc ? '<span class="acua-flyout__desc">' + escapeHtml(desc) + '</span>' : '') + '</span>'
        + '<span class="acua-flyout__chev">' + CHEVRON + '</span></a>';
    });
    panel.innerHTML = html + '</div>';
    return true;
  }

  function openFor(trigger) {
    build();
    if (!render(trigger)) return;
    if (current && current !== trigger) current.setAttribute('aria-expanded', 'false');
    current = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    portal.classList.add('is-open');
    if (touch()) {
      portal.classList.add('acua-flyout--sheet');
      portal.classList.remove('is-flipped');
      scrim.classList.add('is-open');
    } else {
      portal.classList.remove('acua-flyout--sheet');
      scrim.classList.remove('is-open');
      position(trigger);
    }
  }

  function position(trigger) {
    var r = trigger.getBoundingClientRect();
    portal.style.visibility = 'hidden';
    portal.style.left = '0px';
    portal.style.top = '0px';
    var pw = panel.offsetWidth, ph = panel.offsetHeight;
    var vw = window.innerWidth, vh = window.innerHeight;
    var left = r.left + r.width / 2 - pw / 2;
    if (left < 12) left = 12;
    if (left + pw > vw - 12) left = vw - 12 - pw;
    var top = r.bottom + 14, flip = false;
    if (top + ph > vh - 12 && r.top - ph - 14 > 12) {
      top = r.top - ph - 14;
      flip = true;
    }
    portal.classList.toggle('is-flipped', flip);
    portal.style.left = Math.round(left) + 'px';
    portal.style.top = Math.round(top) + 'px';
    var cx = r.left + r.width / 2 - left;
    cx = Math.max(18, Math.min(pw - 18, cx));
    caret.style.left = Math.round(cx) + 'px';
    portal.style.visibility = '';
  }

  function scheduleClose() { cancelClose(); closeT = setTimeout(close, 160); }
  function cancelClose() { if (closeT) { clearTimeout(closeT); closeT = null; } }
  function close() {
    cancelClose();
    if (!portal) return;
    portal.classList.remove('is-open');
    scrim.classList.remove('is-open');
    if (current) {
      current.setAttribute('aria-expanded', 'false');
      current = null;
    }
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-acua-flyout]');
    Array.prototype.forEach.call(nodes, function (t) {
      if (t.__acua) return;
      t.__acua = true;
      t.addEventListener('mouseenter', function () { if (!touch()) { cancelClose(); openFor(t); } });
      t.addEventListener('mouseleave', function () { if (!touch()) scheduleClose(); });
      t.addEventListener('focusin', function () { if (!touch()) openFor(t); });
      t.addEventListener('focusout', function (e) { if (!touch() && !t.contains(e.relatedTarget)) scheduleClose(); });
      t.addEventListener('click', function (e) {
        if (touch()) {
          e.preventDefault();
          e.stopPropagation();
          if (current === t && portal && portal.classList.contains('is-open')) close();
          else openFor(t);
        }
      }, true);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openFor(t);
          var first = panel && panel.querySelector('.acua-flyout__item');
          if (first) first.focus();
        } else if (e.key === 'Escape') {
          close();
          t.focus();
        }
      });
    });
  }

  function reposition() {
    if (!current || !portal.classList.contains('is-open') || touch()) return;
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      if (current) position(current);
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    if (!portal || !portal.classList.contains('is-open')) return;
    if (portal.contains(e.target)) return;
    if (current && current.contains(e.target)) return;
    close();
  });
  window.addEventListener('scroll', reposition, true);
  window.addEventListener('resize', reposition);

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.AcuaFlyoutLoaded) return;
  window.AcuaFlyoutLoaded = true;

  var ICONS = {
    grid: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
    equipo: '<path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>',
    refacciones: '<path d="M14.7 6.3a4 4 0 0 0-5.66 5.66L3 18l3 3 6.04-6.04a4 4 0 0 0 5.66-5.66l-2.51 2.51a1.5 1.5 0 0 1-2.12-2.12l2.63-2.39z"/>',
    repuesto: '<circle cx="12" cy="12" r="3"/><path d="M19.4 13a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.11-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 13a1.7 1.7 0 0 0-1.56-1.04H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 6.85a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6h.07A1.7 1.7 0 0 0 10 3.05V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15 4.6a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9v.07a1.7 1.7 0 0 0 1.55 1.02H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51.91z"/>',
    membrana: '<ellipse cx="12" cy="5" rx="7" ry="2.6"/><path d="M5 5v14c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6V5"/>',
    filtro: '<path d="M3 4h18l-7 8v7l-4 2v-9L3 4z"/>',
    bomba: '<circle cx="12" cy="12" r="9"/><path d="M12 12V7"/><path d="M12 12l3.5-2"/>',
    gota: '<path d="M12 3s6 6.5 6 10a6 6 0 0 1-12 0c0-3.5 6-10 6-10z"/>',
    quimico: '<path d="M9 3h6"/><path d="M10 3v6l-5.2 9A1.5 1.5 0 0 0 6.1 20.2h11.8A1.5 1.5 0 0 0 19.2 18L14 9V3"/>',
    accesorio: '<path d="M14.7 6.3a4 4 0 0 0-5.66 5.66L3 18l3 3 6.04-6.04a4 4 0 0 0 5.66-5.66l-2.51 2.51a1.5 1.5 0 0 1-2.12-2.12l2.63-2.39z"/>'
  };
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  function svg(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || ICONS.equipo) + '</svg>';
  }
  function touch() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var portal, panel, caret, scrim, current = null, closeT = null, rafPending = false;

  function build() {
    if (portal) return;
    scrim = document.createElement('div');
    scrim.className = 'acua-flyout-scrim';
    scrim.addEventListener('click', close);

    portal = document.createElement('div');
    portal.className = 'acua-flyout';
    caret = document.createElement('span');
    caret.className = 'acua-flyout__caret';
    panel = document.createElement('div');
    panel.className = 'acua-flyout__panel';
    portal.appendChild(caret);
    portal.appendChild(panel);

    portal.addEventListener('mouseenter', function () { if (!touch()) cancelClose(); });
    portal.addEventListener('mouseleave', function () { if (!touch()) scheduleClose(); });

    document.body.appendChild(scrim);
    document.body.appendChild(portal);
  }

  function render(trigger) {
    var src = trigger.querySelector('.acua-cat-card__source');
    if (!src) return false;
    var title = src.getAttribute('data-title') || '';
    var links = src.querySelectorAll('.acua-sub');
    var html = title ? '<p class="acua-flyout__title">' + escapeHtml(title) + '</p>' : '';
    html += '<div class="acua-flyout__list">';
    Array.prototype.forEach.call(links, function (a) {
      var isAll = a.classList.contains('acua-sub--all');
      var icon = isAll ? 'grid' : (a.getAttribute('data-icon') || 'equipo');
      var img = a.getAttribute('data-img');
      var desc = a.getAttribute('data-desc') || '';
      var label = (a.textContent || '').trim();
      var icoInner = (!isAll && img) ? '<img src="' + img + '" alt="" loading="lazy">' : svg(icon);
      var icoClass = 'acua-flyout__ico' + ((!isAll && img) ? ' acua-flyout__ico--img' : '');
      html += '<a class="acua-flyout__item' + (isAll ? ' acua-flyout__item--all' : '') + '" href="' + a.getAttribute('href') + '" role="menuitem">'
        + '<span class="' + icoClass + '">' + icoInner + '</span>'
        + '<span class="acua-flyout__txt"><span class="acua-flyout__lbl">' + escapeHtml(label) + '</span>'
        + (desc ? '<span class="acua-flyout__desc">' + escapeHtml(desc) + '</span>' : '') + '</span>'
        + '<span class="acua-flyout__chev">' + CHEVRON + '</span></a>';
    });
    panel.innerHTML = html + '</div>';
    return true;
  }

  function openFor(trigger) {
    build();
    if (!render(trigger)) return;
    if (current && current !== trigger) current.setAttribute('aria-expanded', 'false');
    current = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    portal.classList.add('is-open');
    if (touch()) {
      portal.classList.add('acua-flyout--sheet');
      portal.classList.remove('is-flipped');
      scrim.classList.add('is-open');
    } else {
      portal.classList.remove('acua-flyout--sheet');
      scrim.classList.remove('is-open');
      position(trigger);
    }
  }

  function position(trigger) {
    var r = trigger.getBoundingClientRect();
    portal.style.visibility = 'hidden';
    portal.style.left = '0px';
    portal.style.top = '0px';
    var pw = panel.offsetWidth, ph = panel.offsetHeight;
    var vw = window.innerWidth, vh = window.innerHeight;
    var left = r.left + r.width / 2 - pw / 2;
    if (left < 12) left = 12;
    if (left + pw > vw - 12) left = vw - 12 - pw;
    var top = r.bottom + 14, flip = false;
    if (top + ph > vh - 12 && r.top - ph - 14 > 12) {
      top = r.top - ph - 14;
      flip = true;
    }
    portal.classList.toggle('is-flipped', flip);
    portal.style.left = Math.round(left) + 'px';
    portal.style.top = Math.round(top) + 'px';
    var cx = r.left + r.width / 2 - left;
    cx = Math.max(18, Math.min(pw - 18, cx));
    caret.style.left = Math.round(cx) + 'px';
    portal.style.visibility = '';
  }

  function scheduleClose() { cancelClose(); closeT = setTimeout(close, 160); }
  function cancelClose() { if (closeT) { clearTimeout(closeT); closeT = null; } }
  function close() {
    cancelClose();
    if (!portal) return;
    portal.classList.remove('is-open');
    scrim.classList.remove('is-open');
    if (current) {
      current.setAttribute('aria-expanded', 'false');
      current = null;
    }
  }

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-acua-flyout]');
    Array.prototype.forEach.call(nodes, function (t) {
      if (t.__acua) return;
      t.__acua = true;
      t.addEventListener('mouseenter', function () { if (!touch()) { cancelClose(); openFor(t); } });
      t.addEventListener('mouseleave', function () { if (!touch()) scheduleClose(); });
      t.addEventListener('focusin', function () { if (!touch()) openFor(t); });
      t.addEventListener('focusout', function (e) { if (!touch() && !t.contains(e.relatedTarget)) scheduleClose(); });
      t.addEventListener('click', function (e) {
        if (touch()) {
          e.preventDefault();
          e.stopPropagation();
          if (current === t && portal && portal.classList.contains('is-open')) close();
          else openFor(t);
        }
      }, true);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openFor(t);
          var first = panel && panel.querySelector('.acua-flyout__item');
          if (first) first.focus();
        } else if (e.key === 'Escape') {
          close();
          t.focus();
        }
      });
    });
  }

  function reposition() {
    if (!current || !portal.classList.contains('is-open') || touch()) return;
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      if (current) position(current);
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    if (!portal || !portal.classList.contains('is-open')) return;
    if (portal.contains(e.target)) return;
    if (current && current.contains(e.target)) return;
    close();
  });
  window.addEventListener('scroll', reposition, true);
  window.addEventListener('resize', reposition);

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
